'use client';

import { Link } from '@heroui/link';
import SocialMediaIcons from '../social-icon';
import { motion } from 'framer-motion';
import StoreIcons from './StoreIcons';

// Footer Data
const footerData = {
  companyInfo: {
    name: 'PayStop',
    description: [
      'PayStop is powered by KiiBase Ltd, a company registered in Cameroon (RC.BDA.2025B.000206) and authorised by the Telecommunications Regulatory Board (ART) to provide Mobile Financial Services.',
      'Crystal Finance Commercial Avenue Bamenda, P.O. Box 168 Bamenda Cameroon',
    ],
  },
  menus: [
    {
      title: 'Quick Links',
      links: [
        { name: 'About Us', href: '/about-us' },
        { name: 'Contact Us', href: '/contact-us' },
        { name: 'FAQ', href: '/faq' },
        { name: 'Security', href: '/security' },
        { name: 'Report Fraud', href: '/report-fraud' },
        // { name: 'PayStop App', href: 'https://PayStop.app/' },
      ],
    },
    {
      title: 'Features',
      links: [
        { name: 'Pricing', href: '/pricing' },
        { name: 'Agent Network', href: '/agent-network' },
        { name: 'How it Works', href: '/how-it-works' },
        { name: 'Become an Agent', href: '/become-an-agent' },
        // { name: 'Blog', href: '/blog' },
      ],
    },
    {
      title: 'Other Links',
      links: [
        { name: 'Site Terms of Use', href: '/site-terms-of-use' },
        { name: 'Privacy Notice', href: '/privacy-notice' },
        { name: 'Terms and Conditions', href: '/terms-and-conditions' },
        { name: 'Cookie Policy', href: '/cookie-policy' },
      ],
    },
  ],
};

export default function Footer() {
  return (
    <footer className="w-full bg-gradient-to-b from-primary/5 to-primary/10 dark:from-transparent dark:to-transparent">
      <div className="container container-max">
        <motion.div
          whileInView={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="grid grid-cols-2 gap-3 py-10 mx-auto sm:grid-cols-5 lg:grid-cols-5 gap-y-8 md:gap-5"
        >
          {/* Company Info */}
          <div className="mb-10 space-y-5 col-span-full lg:col-span-2 lg:mb-0">
            <h4 className="text-base font-medium text-foreground mb-7">
              {footerData.companyInfo.name}
            </h4>
            <div className="space-y-3 text-sm text-foreground/60 lg:max-w-lg">
              {footerData.companyInfo.description.map((text, index) => (
                <p key={index}>{text}</p>
              ))}
            </div>

            <div className="flex flex-col gap-5">
              <StoreIcons />
            </div>
            <div className="flex justify-left">
              <SocialMediaIcons />
            </div>
          </div>

          {/* Dynamic Menus */}
          {footerData.menus.map((menu, index) => (
            <div key={index} className="text-left lg:mx-auto">
              <h4 className="text-base font-medium text-foreground mb-7">{menu.title}</h4>
              <ul className="text-sm transition-all duration-500">
                {menu.links.map((link, linkIndex) => (
                  <li key={linkIndex} className="mb-6">
                    <Link
                      className="text-foreground/60 hover:text-primary"
                      href={link.href}
                      size="sm"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </motion.div>

        {/* Footer Bottom */}
        <div className="border-t border-divider py-7">
          <div className="flex flex-col items-center justify-center text-sm lg:justify-between lg:flex-row text-foreground/60">
            <span>© {footerData.companyInfo.name} 2025, All rights reserved.</span>
            <span>
              Designed and developed by{' '}
              <Link
                className="text-primary hover:underline"
                href="https://technofex.com/"
                isExternal
              >
                TechnoFex
              </Link>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
